import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import Container from "@mui/material/Container";
import { Typography, Grid, Card, CardContent, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getSocietyById } from "../../../services/societies";
import { AssignedClientsCard } from "./AssignedClientsCard";
import { useHistory } from "react-router-dom";
import SectionTitle from "../../SectionTitle";
import { authContext } from "../../../contexts/AuthContext";
import SocietyCompliances from "./SocietyCompliances";
import i18next from "i18next";
import { getCountryLabel } from "../../../Utils/getCountryLabel";

export const SociedadDetalle = () => {
  const { society_id } = useParams();
  const { t } = useTranslation();
  const [society, setSociety] = useState(null);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const { auth } = useContext(authContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [socData] = await Promise.all([getSocietyById(society_id)]);
        setSociety(socData);
      } catch (err) {
        console.error("Error fetching society data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [society_id]);

  async function fetchCountryLabel() {
    if (society && society.country) {
      const countryLabel = await getCountryLabel(
        society.country,
        i18next.language,
      );
      setSociety((prevSociety) => ({
        ...prevSociety,
        countryLabel: countryLabel,
      }));
    }
  }

  useEffect(() => {
    fetchCountryLabel();
  }, [i18next.language, t]);

  if (loading) return <Typography>{t("Loading...")}</Typography>;
  if (!society) return <Typography>{t("No society found")}</Typography>;

  const languageMap = {
    es: t("Spanish"),
    en: t("English"),
  };

  const statusMap = {
    active: t("Active"),
    inactive: t("Inactive"),
  };

  const typeMap = {
    "S.A": t("SA"),
    "S.R.L": t("SRL"),
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container justifyContent="space-between">
        <Typography variant="h5" gutterBottom>
          {t("Society Detail")}
        </Typography>

        {auth.type !== "client" && (
          <Button
            sx={{
              m: 3,
              backgroundColor: window.$brand === "PRB" ? "#17afb6" : "#102a46",
              borderRadius: window.$brand === "PRB" ? 0 : 5,
            }}
            variant="contained"
            onClick={() => {
              history.push("/AdministracionSociety", { society: society });
            }}
          >
            {t("go_to_settings")}
          </Button>
        )}
      </Grid>

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <SectionTitle>{t("General Information")}</SectionTitle>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={6}>
              <strong>{t("Type")}:</strong>{" "}
              {typeMap[society.type] || society.type}
            </Grid>
            <Grid item xs={6}>
              <strong>{t("Legal ID")}:</strong> {society?.legal_id}
            </Grid>
            <Grid item xs={6}>
              <strong>{t("Constitution Date")}:</strong>{" "}
              {society.constitution_date
                ? new Date(society.constitution_date).toLocaleDateString()
                : "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>{t("Corporate Address")}:</strong> {society?.address}
            </Grid>
            <Grid item xs={6}>
              <strong>{t("Country")}:</strong> {society?.countryLabel}
            </Grid>
            <Grid item xs={6}>
              <strong>{t("Contact Email")}:</strong>{" "}
              {society?.contact_email || "-"}
            </Grid>
            
            <Grid item xs={6}>
              <strong>{t("WhatsApp")}:</strong>{" "}
              {society.phone_country_code && society.phone_number
                ? `+${society?.phone_country_code}${society?.phone_number}`
                : "-"}
            </Grid>
            <Grid item xs={6}>
              <strong>{t("Language")}:</strong>{" "}
              {languageMap[society.language] || society.language}
            </Grid>
            <Grid item xs={6}>
              <strong>{t("Current Status")}:</strong>{" "}
              {statusMap[society.current_status] || society.current_status}
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <AssignedClientsCard societyId={society_id} adminMode={false} />
      {society && <SocietyCompliances society={society} adminMode={false} />}
    </Container>
  );
};
